import type React from 'react'

interface Props {
  className?: string
}

// Три столбика GA4 в фирменных пропорциях. Цвет — currentColor, чтобы
// иконка жила и на синей кнопке, и на серой.
export const GaIcon: React.FC<Props> = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="1"
        y="9"
        width="3.4"
        height="6"
        rx="1.4"
        fill="currentColor"
        opacity="0.65"
      />
      <rect
        x="6.3"
        y="5.5"
        width="3.4"
        height="9.5"
        rx="1.4"
        fill="currentColor"
        opacity="0.82"
      />
      <rect
        x="11.6"
        y="1"
        width="3.4"
        height="14"
        rx="1.4"
        fill="currentColor"
      />
    </svg>
  )
}
